import Adjectives from "../../components/ClassTwo/English/Adjectives";
import AmIsAreWasWere from "../../components/ClassTwo/English/AmIsAreWasWere";
import Articles from "../../components/ClassTwo/English/Articles";
import Comprehension from "../../components/ClassTwo/English/Comprehension";
import Gender from "../../components/ClassTwo/English/Gender";
import Nouns from "../../components/ClassTwo/English/Nouns";
import Prepositions from "../../components/ClassTwo/English/Prepositions";
import Pronoun from "../../components/ClassTwo/English/Pronoun";
import SentencePhrases from "../../components/ClassTwo/English/SentencePhrases";
import SingularPlural from "../../components/ClassTwo/English/SingularPlural";
import TheVerbs from "../../components/ClassTwo/English/TheVerbs";
import WillBeShallBe from "../../components/ClassTwo/English/WillBeShallBe";
import YesterdayTodayTomorrow from "../../components/ClassTwo/English/YesterdayTodayTomorrow";
import OppositeWords from "../../components/UKG/English/OppositeWords";
import NounsMenu from "../../menus/ClassTwo/Nouns";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-two/english/nouns", title: "Noun – Naming Words", component: Nouns, subMenu: NounsMenu },
    { url: "/class-two/english/singular-plural", title: "Singular and Plural", component: SingularPlural },
    { url: "/class-two/english/sentence-phrase", title: "Sentence and Phrase", component: SentencePhrases },
    { url: "/class-two/english/gender", title: "Gender", component: Gender },
    { url: "/class-two/english/pronoun", title: "Pronoun", component: Pronoun },
    { url: "/class-two/english/adjectives", title: "Adjectives", component: Adjectives },
    { url: "/class-two/english/articles", title: "Articles", component: Articles },
    { url: "/class-two/english/verb", title: "The Verb", component: TheVerbs },
    { url: "/class-two/english/is-am-are-was-were", title: "Is, Am, Are, Was and Were", component: AmIsAreWasWere },
    { url: "/class-two/english/will-be-shall-be", title: "Will be and Shall be", component: WillBeShallBe },
    { url: "/class-two/english/yesterday-today-tomorrow", title: "Yesterday, Today, Tomorrow", component: YesterdayTodayTomorrow },
    { url: "/class-two/english/preposition", title: "Preposition", component: Prepositions },
    { url: "/class-two/english/opposite-words", title: "Opposite Words", component: OppositeWords },
    { url: "/class-two/english/comprehension", title: "Comprehension", component: Comprehension }
];


export default topics;